import { connect } from 'react-redux';
import SiteGates from './siteGates';
import { bindActionCreators } from 'redux';
import {
  getgatesByleadId,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    siteGatesData: state.siteListingReducer.siteGates
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getgatesByleadId
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteGates);
